import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TrackByService {
  public static trackById(item: any): number | string {
    return item?.id;
  }

  constructor() {}
}
